import baseConf from './base.conf'

export default {
  ...baseConf,
  glapiHost: 'https://geekline.org',
  get glapiBaseUri () { return this.glapiHost + this.glapiRootUri },
  // paypalPartnerClientId: 'AVHNDPHWIBV-bR597yx-ZCuwKO53I3kZgnnjOz7BX5H1rxv_695I6o2-5TqWTY-n1bRLN8WiwRDY_0OI'
  // paypalPartnerClientId: 'AXgtiMtuSIYwBZfXo_adUjAf0cMHJWZrmTMQrZBn0DLLgLzCFwlL8R4wz8HSm4AD0i2NVDjBs8yj6u-q'
  paypalPartnerClientId: 'AUl28ocY5Ps3T1Y9ycm32vyOM5SlV0ijL4af1K5UJCz9m59YJR4JR3HQBK1-2tyl1l17K4MKKGv7eb7p'
}
